export default {
    title: "Adresverificatie",
    header: "@:views.address.verified.title",
    message: "Bedankt voor het verifiëren van je adres. U kunt dit nu als verzendadres kiezen wanneer u een bestelling plaatst.",
}